 
(function($) {
  // 等待 Ultimate_Shopify_DataLayer 实例化完成
  const waitForDataLayer = setInterval(() => {
    if (window.dataLayer) {
      clearInterval(waitForDataLayer);
      init();
    }
  }, 100);

  function replaceButtons() {
    $('.vtl-ub-suggestion__add-to-cart').each(function() {
      const $btn = $(this);
      if (!$btn.hasClass('converted-to-div')) {
        const href = $btn.attr('href');
        const text = $btn.text();
        const styles = window.getComputedStyle($btn[0]);
         
        // 创建新的div元素
        const $div = $('<div>', {
          class: 'vtl-ub-suggestion__add-to-cart converted-to-div',
          text: text,
          css: {
            cursor: 'pointer',
            backgroundColor: styles.backgroundColor,
            color: styles.color,
            padding: styles.padding,
            margin: styles.margin,
            border: styles.border,
            borderRadius: styles.borderRadius,
            display: 'inline-block',
            textAlign: 'center'
          },
          'data-href': href
        });
        
        // 替换原始按钮
        $btn.replaceWith($div);
      }
    });
  }

  function init() {
    // 定期检查并替换按钮
    setInterval(replaceButtons, 500);

    // 使用事件委托处理点击
    $(document).on('click', '.vtl-ub-suggestion__add-to-cart.converted-to-div', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const $div = $(this);
      const href = $div.data('href');
      const variantId = href.match(/id=(\d+)/)[1];
     
   
      // 添加点击效果
      $div.css('opacity', '0.7');
      
      fetch(`/variants/${variantId}.js`)
        .then(res => res.json())
        .then(data => {

           
            // 触发 add_to_cart 事件
            window.dataLayer.push({ 'ecommerce': null });
            window.dataLayer.push({
              'event': 's_add_to_cart_upsell_suggestion',
              'ecommerce': {
                'currency': $("html").attr("currency"),
                'value': parseFloat((data.price / 100).toFixed(2)),
                'items': [{
                  'item_id': data.sku,   
                  'variant_id': data.id, 
                  'item_name': data.name,     
                  'price': parseFloat((data.price / 100).toFixed(2)),
                  'quantity':1,
                  'discount': 0,
                  'item_brand': data.vendor,
                  'category': data.product_type
                }]
              }
            });
             
            // 延迟跳转以确保事件被触发
            setTimeout(() => {
              window.location.href = href;
            }, 300);
       
        })
        .catch(err => {
          console.error('Error:', err);
          // 发生错误时直接跳转
          window.location.href = href;
        })
        .finally(() => {
          // 恢复透明度
          setTimeout(() => {
            $div.css('opacity', '1');
          }, 500);
        });
        
      return false;
    });
  }
})(jQuery); 
 